import { PrimaryClientType } from 'api/types/entity';
import { ClientField as ClientFieldBase } from 'components';
import { useIsFormEditable } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { Input } from 'libs/ui';
import { ClientAutocompleteFeature } from 'modules/operation/common/features';
import { useField } from 'modules/operation/common/forms/operationForm';
import { OperationMode } from 'modules/operation/common/types';

interface ClientFieldProps {
  mode: OperationMode;
  disabled?: boolean;
}

export const ClientField = ({ mode, disabled }: ClientFieldProps) => {
  const { t } = useTranslation();

  const editable = useIsFormEditable();

  const { field: clientTypeField } = useField('clientType');
  const { field: clientField } = useField('client');

  const personalAccountNumberComponent = (
    <Input
      showCopyButton
      disabled={editable}
      label={t(
        'operation.sections.clientsOrderSection.fields.clientPersonalAccountNumber.label'
      )}
      value={clientField.value?.record?.personalAccountNumber ?? ''}
    />
  );

  const clientEmptyComponent = (
    <Input
      showCopyButton
      showRequiredMark
      disabled={editable}
      label={t('operation.sections.clientsOrderSection.fields.client.label')}
      placeholder={t(
        'operation.sections.clientsOrderSection.fields.client.placeholder'
      )}
    />
  );

  if (editable) {
    return (
      <>
        {!clientTypeField?.value?.value ? (
          // if not selected client type, show disabled input
          clientEmptyComponent
        ) : (
          <ClientAutocompleteFeature
            clientType={clientTypeField.value.value}
            disabled={disabled}
          />
        )}
        {mode === 'view' && personalAccountNumberComponent}
      </>
    );
  }

  return (
    <>
      {clientField?.value?.record ? (
        <ClientFieldBase
          clientId={clientField?.value.record.id}
          clientName={clientField?.value.record.name}
          clientType={
            clientTypeField?.value?.value === PrimaryClientType.Client
              ? 'person'
              : 'legal'
          }
          label={t(
            'operation.sections.clientsOrderSection.fields.client.label'
          )}
        />
      ) : (
        clientEmptyComponent
      )}
      {personalAccountNumberComponent}
    </>
  );
};
